export default "__VITE_ASSET__$lnj3tp7__"